import type { SVGProps } from "react";

/** Paths copied from the reference's symbol sheet. Stroke colour is `currentColor`, set by the parent. */
const PATHS = {
  search: "M18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0zM20 20l-4-4",
  bell: "M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0",
  down: "m7 10 5 5 5-5",
  menu: "M4 7h16M4 12h16M4 17h16",
  x: "M6 6l12 12M18 6 6 18",
  check: "m5 12.5 4.5 4.5L19 7.5",
  home: "M4 11 12 4l8 7v9h-5v-6H9v6H4z",
  users: "M12.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3 20c.5-4 3-6 6-6s5.5 2 6 6M16 5a3.5 3.5 0 0 1 0 6.5M18 14c1.8.8 2.8 3 3 6",
  bill: "M6 3h12v18l-3-1.8L12 21l-3-1.8L6 21zM9 8h6M9 12h6",
  wallet: "M4 7h15a1 1 0 0 1 1 1v11H5a1 1 0 0 1-1-1zM4 7c0-2 1-3 3-3h10v3M16 13h1",
  inbox: "M4 13 6.5 5h11L20 13v6H4zM4 13h5l1 2.5h4l1-2.5h5",
  dumbbell: "M3 9.5v5M6 7v10M18 7v10M21 9.5v5M6 12h12",
  finger: "M7 5.5A8 8 0 0 1 20 12v2M4 10a8 8 0 0 1 1.5-3M4.5 15.5A12 12 0 0 0 5 12a7 7 0 0 1 .4-2.3M8 12a4 4 0 0 1 8 0c0 3-.5 5.5-1.5 7.5M12 12c0 3.5-1 6.5-3 8.5M8 15.5c-.3 1.5-.9 2.8-1.7 4",
  badge: "M6 5h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM14.5 11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM8 17c.6-1.6 2.1-2.5 4-2.5s3.4.9 4 2.5M10 3h4",
  cash: "M4.5 6.5h15A1.5 1.5 0 0 1 21 8v8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16V8a1.5 1.5 0 0 1 1.5-1.5zM14.5 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM6.5 9.5v.5M17.5 14v.5",
  receipt: "M5 4h14v16l-2.3-1.3L14.3 20 12 18.7 9.7 20l-2.4-1.3L5 20zM9 9h6M9 13h3",
  chart: "M4 4v16h16M8 16v-4M12 16V8M16 16v-6",
  gear: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM12 3.5v2.5M12 18v2.5M3.5 12H6M18 12h2.5M6 6l1.8 1.8M16.2 16.2 18 18M6 18l1.8-1.8M16.2 7.8 18 6",
  plus: "M12 5v14M5 12h14",
  up: "M12 19V5M6 11l6-6 6 6",
  dn: "M12 5v14M6 13l6 6 6-6",
  clock: "M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0zM12 7v5.5l3.5 2",
  trial: "M13.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3.5 20c.5-4 3-6 6.5-6 1.4 0 2.6.3 3.6.9M16 18l2 2 4-4.5",
  user: "M16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM4.5 20c.8-4 3.8-6 7.5-6s6.7 2 7.5 6",
  logout: "M10 4H5v16h5M15 8l4 4-4 4M19 12H9",
  phone: "M6.5 4h3l1.5 4-2 1.3a10 10 0 0 0 5.7 5.7L16 13l4 1.5v3A2 2 0 0 1 18 19.5 15.5 15.5 0 0 1 4.5 6 2 2 0 0 1 6.5 4z",
  chat: "M4.5 19.5 5.6 16A7.5 7.5 0 1 1 8.4 18.6zM9 10.5c.3 1.8 2 3.6 4 4l1.2-1.2 1.6.8",
  alert: "M12 4 3 20h18zM12 10v4.5M12 17.5v.5",
  swap: "M7 4 3 8l4 4M3 8h14M17 20l4-4-4-4M21 16H7",
  back: "m15 5-7 7 7 7",
  chevR: "m9 5 7 7-7 7",
  lock: "M7 11V8a5 5 0 0 1 10 0v3M6 11h12v9H6z",
  send: "M21 3 3 10.5l7 3 3 7zM10 13.5 21 3",
  tick2: "m2.5 12.5 4.5 4.5L15 8.5M10 15l1.5 1.5L21 7.5",
  archive: "M4 6h16v4H4zM5.5 10v9h13v-9M10 14h4",
  mail: "M4 6h16v12H4zM4 7l8 6 8-6",
  file: "M7 3h7l4 4v14H7zM14 3v4h4",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  info: "M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0zM12 11v5M12 8v.5",
  grid: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z",
} as const;

export type IconName = keyof typeof PATHS;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: IconName;
  size?: number;
  strokeWidth?: number;
}

/** Decorative by default (`aria-hidden`); pass `aria-label` to expose it. */
export function Icon({ name, size, strokeWidth, className, ...rest }: IconProps) {
  const heavy = name === "up" || name === "dn";
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth ?? (heavy ? 2.2 : name === "check" ? 1.8 : 1.6)}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={rest["aria-label"] ? undefined : true}
      className={className}
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

/** The gym logo tile glyph (white strokes on the tile). */
export function GymGlyph(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" aria-hidden="true" {...props}>
      <path d="M4 9.5v5M7 7.5v9M17 7.5v9M20 9.5v5M7 12h10" />
    </svg>
  );
}
